<app-audit-logs [headerTextSize]="32"></app-audit-logs>
